/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Table, Button, Form, Col } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { getUserList, getSearchedUsers } from '../../actions/userListActions'
import withLoginRequired from '../../HOC/LoginModal'
import { APIGetPendingApprovals } from '../../utils/config/API'

export default withLoginRequired(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userListData = useSelector((state) => state.userList.userList)
  const searchedUsers = useSelector((state) => state.searchedUsers.searchedUsers)

  const [currPage, setCurrPage] = useState(1)
  const [usersPerPage, setUsersPerPage] = useState(25)
  const [searchText, setSearchText] = useState('')
  const [showSearched, setShowSearched] = useState(false)

  const list = showSearched ? searchedUsers : userListData

  const handleClick = (params) => {
    window.open(`user/edit-user/${params}`)
  }

  useEffect(() => {
    dispatch(getUserList(0, 100))
  }, [dispatch])

  const indexOfLastUser = currPage * usersPerPage
  const indexOfFirstUser = indexOfLastUser - usersPerPage

  let tableBodyComponent = null

  if (list !== undefined && list !== null && typeof list === 'object' && list.length > 0) {
    console.log('Should not make it here if list is empty', list)
    tableBodyComponent = list?.map((userData) => {
      return (
        <tr>
          <td>Yuvraj</td>
          <td>tech@collegepass.org</td>
          <td>9</td>
          <td>Paramvir</td>
          <td>
            <Button component={Link} to="/add-premium-plus-user-sales" className="btn-primary highlighted">
              Review
            </Button>
          </td>
        </tr>
      )
    })
  }
  // <td>{userData.ISPREMIUM === 2 ? 'prime' : 'basic'}</td>

  const [forms, setForms] = useState([])
  const [filteredForms, setFilteredForms] = useState([])
  useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(APIGetPendingApprovals, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        setForms(res.data)
        setFilteredForms(res.data)
      } catch (err) {
        console.log('Error', err)
      }
    }
    getData()
  }, [])
  const onSearchHandler = (e) => {
    if (searchText) {
      e.preventDefault()
      // dispatch(getSearchedUsers(searchText))
      setFilteredForms(
        forms.filter(
          (item) =>
            item.STUDENT_EMAIL?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.STUDENT_FIRST_NAME?.concat(item.STUDENT_LAST_NAME).toLowerCase().includes(searchText.toLowerCase()) ||
            item.SALES_PERSON_EMAIL?.toLowerCase().includes(searchText.toLowerCase())
        )
      )
      setShowSearched(true)
    } else {
      setFilteredForms(forms)
    }
  }

  return (
    <Container fluid className="w-100">
      <Row className="heading mb-3">
        <h3 className="title">
          User List
          {/* {userListData !== undefined
            ? userListData.length > 0
              ? userListData.length
              : 0
            : 0}
          ) */}
        </h3>
      </Row>

      <Row className="mb-3 w-50 pr-3">
        <Col>
          <Form onSubmit={onSearchHandler}>
            <Form.Control
              type="text"
              placeholder="Enter Email / Name / Sales Person"
              value={searchText}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  console.log('Entered')
                  onSearchHandler(event)

                  // console.log('Enter key pressed!')
                  // You can trigger any function here
                }
              }}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Form>
        </Col>
        <Col>
          <Link to="/add-student">
            {/* <Button
              className="btn-primary"
              // onClick={handleSubmit}
              style={{
                padding: '8px 12px',
                fontSize: '1rem',
              }}
            >
              ADD
            </Button> */}
          </Link>
        </Col>
      </Row>

      {!(typeof list === 'string' && list.length) ? (
        <Row>
          <Table responsive className="table">
            <thead>
              <tr>
                <th>First name</th>
                <th>Email</th>
                <th>Grade</th>
                {/* <th>Sales person Name</th> */}
                <th>Sales person Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredForms.map((item) => {
                return (
                  <tr>
                    <td>{item.STUDENT_FIRST_NAME}</td>
                    <td>{item.STUDENT_EMAIL}</td>
                    <td>{item.GRADE_LEVEL}</td>
                    <td>{item.SALES_PERSON_EMAIL}</td>
                    {/* <td>aramvir@collegepass.org</td> */}
                    <td>
                      <Link to={`/add-premium-plus-user-sales/${item.UUID}`}>
                        <Button className="btn-primary highlighted">Review</Button>
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Row>
      ) : (
        tableBodyComponent
      )}
    </Container>
  )
})
